import * as _ from 'lodash';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';
import { RaffleDrawService } from 'app/core/services/raffle-draw.service';
import { ToastService } from 'app/toast/services/toast.service';
import { loadManageCampaignList } from 'app/campaign/features/campaign.actions';
import { SharedService } from 'app/virtual-event/services/shared.service';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ViewRaffleWinnersComponent } from 'app/manage-tickets-and-guests/modals/view-raffle-winners/view-raffle-winners.component';
import { CommonModule } from '@angular/common';

@Component({
  standalone:true,
  imports:[CommonModule],
  selector: 'app-raffle-draw',
  templateUrl: './raffle-draw.component.html',
  styleUrls: ['./raffle-draw.component.scss']
})
export class RaffleDrawComponent implements OnInit {
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));

  onClose: Function;
  data:any;
  isSimpleRaffle: boolean | null;
  isArray:boolean;
  campaign: any;

  constructor(
    private store: Store,
    private dialogService: DialogService,
    private raffleHttp:RaffleDrawService,
    private toastService:ToastService,
    private sharedService:SharedService,
    private modalService: MdbModalService,
  ) { }

  ngOnInit(): void {
    if(this.isArray){
      this.data = _.sortBy(this.data, (item) => {
        return item?.BasketRaffleItem?.name;
      })
    }

    
  }

  getImg(img){
    return img !== '' ? img : '/images/org_logo_default_v2.svg'
  }

  onConfirmSaveWinners(saveWinnersCallback){
    const action = DialogActions.openDialog({
      payload: {
        name: "confirmComponent",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          modalTitle: "Save winners",
          text: `Are you sure you want to replace previous winners with new winners?`,
          buttonCancel: "No",
          buttonConfirm: "Yes",
          callback: (value) => {
            if(value){
              saveWinnersCallback()
            }
          }
        }
      }});

    this.store.dispatch(action);
  }

  onShowWinnersClick(){
    this.onClose()
    let isSimpleRaffle = false;
    const raffleWinners = this.campaign.campaignTypeData?.basketRaffleWinners;
    for(let i =0;i<raffleWinners?.length; ++i){
     raffleWinners[i].Winner = raffleWinners[i].winnerUser;
     const basketRaffleItem = this.campaign.campaignTypeData?.basketRaffleItems.find(item => item.id === raffleWinners[i].basketRaffleOptionId)
     raffleWinners[i].BasketRaffleItem = basketRaffleItem;
    }
 
    const simpleBacketWinners = this.campaign.campaignTypeData?.raffleWinners;
    const data = raffleWinners ?? simpleBacketWinners;
    if(raffleWinners){
     isSimpleRaffle = false;
    }
    else if(simpleBacketWinners){
     isSimpleRaffle = true;
    }
 
     let modalRef = this.modalService.open(ViewRaffleWinnersComponent, {
       ignoreBackdropClick: false,
       modalClass:`modal--paybee ${isSimpleRaffle ? '' : 'modal-lg'}`,
       containerClass:'mdb-modal-backdrop-paybee',
       data: {
         isSimpleRaffle,
         campaign: this.campaign,
         data,
         onClose: ()=>{
           modalRef.close()
         }
       }
     });
   
   }

  onSaveWinners(){
    let winners,winner: any;
    if(this.isArray){
      winners = this.data.map(item => 
      {
        return {
          winnerUserId: item.Winner.id,
          basketRaffleOptionId: item.BasketRaffleItem.id
        }
      })
    } else{
      winner = this.data.id;
    }

    const callback = () => {
      this.raffleHttp.saveWinners(this.campaign.id,winners,winner).subscribe({
        next:() => {
          this.toastService.showSuccess('Winners saved successfully')
          this.store.dispatch({
            type: loadManageCampaignList.type,
            payload: this.sharedService.token,
            campaignTypes:[6],
          });
          this.onClose();
        },
  
        error: (error) => {
          this.toastService.showDanger(error.error.errorMessage)
          this.onClose()
        }
      });
    }

    if(this.isArray && this.campaign.campaignTypeData?.basketRaffleWinners){
      this.onConfirmSaveWinners(callback);
      return;
    }

    callback();
    
  }

  onRemoveWinnerFromSimpleRaffle(item){
    this.raffleHttp.removeWinner(this.campaign.id,item.winnerUserId).subscribe({
      next: () => {
        this.toastService.showSuccess('Winner deleted successfully')
        const index = this.data.findIndex(i => i.winnerUserId === item.winnerUserId);
        if (index !== -1) {
            this.data.splice(index, 1);
            this.campaign.campaignTypeData.raffleWinners.splice(index,1)

        }      
      },
    })
  }
}
